import { Input, Select } from "antd";
import React, { useState } from "react";

import "./stylesPromoNotificationForm.css";
import PromotionalCard from "./PromotionalCard";
import { AppStrings } from "../../../../../utils/constants/AppStrings";

const getPromotions = () => [
  {
    id: "purchase_match",
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/ed13c5bcf92ec6798a04dba635016b15ca6bda5a?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/c1686b947bc60b336cc78aa8a60db42609a5efc0?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: AppStrings.PURCHASE_MATCH,
    description: AppStrings.PAM_NEW_PROMOTION_PURCHASE_MATCH_DESC,
    backgroundColor: "#fd6f2780",
  },
  {
    id: "free_bets",
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/73956f454bce9b344eeba328d77304a7627a248f?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/2ab38cc9be5e7ebfd865cb7595b7e2d2a129ce46?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: AppStrings.FREE_BETS,
    description: AppStrings.PAM_NEW_PROMOTION_FREE_BETS_DESC,
    backgroundColor: "#757582",
  },
  {
    id: "profit_boost",
    icon: "https://cdn.builder.io/api/v1/image/assets/TEMP/f9ce1b8f4afd1b4e24551e2e1a18eccb4d8cbec9?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    actionIcon:
      "https://cdn.builder.io/api/v1/image/assets/TEMP/04e29605c9981b14bcb381c8f6cb1699eab4156e?placeholderIfAbsent=true&apiKey=06568d62ba284983b5327a7c2c338200",
    title: AppStrings.PROFIT_BOOST,
    description: AppStrings.PAM_NEW_PROMOTION_PROFIT_BOOST_DESC,
    backgroundColor: "#757582",
  },
];

function PromoNotificationForm({ setActivePromoVariant }) {
  const promotions = getPromotions();
  const [selectedPromo, setSelectedPromo] = useState("purchase_match");

  return (
    <div className="formSection promo-notification-form">
      <div className="email-notification-header">
        <h2>{AppStrings.PROMO_VARIANTS}</h2>
        <button>{AppStrings.SAVE_AS_TEMPLATE}</button>
      </div>
      <div className="promotionsGrid">
        {promotions.map((promo) => (
          <PromotionalCard
            key={promo.id}
            id={promo.id}
            icon={promo.icon}
            title={promo.title}
            description={promo.description}
            isActive={selectedPromo === promo.id}
            setSelectedPromo={setSelectedPromo}
            setActivePromoVariant={setActivePromoVariant}
          />
        ))}
      </div>
      <div className="promo-notification-content">
        <div className="transaction-info">
          <h3>{AppStrings.DEPOSIT_MATCH_PERCENTAGE}</h3>
          <div className="transaction-info-item">
            <span>{AppStrings.MAX_DEPOSIT_MATCH_AMOUNT}</span>
            <Input />
          </div>
        </div>
        <div className="transaction-info">
          <h3>{AppStrings.BONUS_TIME_FRAMES}</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.ALLOCATED_TIME_TO_MAKE_A_PURCHASE}</span>
              <Input placeholder={AppStrings.PAM_NEW_PROMOTION_EX_1} />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.HOURS_OR_DAYS}</span>
              <Input placeholder={AppStrings.PAM_NEW_PROMOTION_EX_DAY} />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.ALLOCATED_TIME_TO_USE_THE_FREE_BET}</span>
              <Input placeholder={AppStrings.PAM_NEW_PROMOTION_EX_1} />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.HOURS_OR_DAYS}</span>
              <Input placeholder={AppStrings.PAM_NEW_PROMOTION_EX_DAY} />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>{AppStrings.BET_TYPES}</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.ELIGIBLE_BET_TYPE}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: AppStrings.ALL },
                  { value: "Single", label: AppStrings.SINGLE },
                  { value: "Multiple", label: AppStrings.MULTIPLE },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.PREMATCH_LIVE}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: AppStrings.ALL },
                  { value: "Prematch", label: AppStrings.PREMATCH },
                  { value: "Live", label: AppStrings.LIVE },
                ]}
              />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.MIN_LEGS}</span>
              <Input placeholder="0" />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.MAX_LEGS}</span>
              <Input placeholder="0" />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>{AppStrings.SPORTSBOOK_REQUIREMENTS}</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.SPORTS}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Soccer", label: "Soccer" },
                  { value: "Tennis", label: "Tennis" },
                  { value: "Basketball", label: "Basketball" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.LEAGUES}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "NBA", label: "NBA" },
                  { value: "NHL", label: "NHL" },
                  { value: "NFL", label: "NFL" },
                ]}
              />
            </div>
          </div>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.TEAMS}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Team A", label: "Team A" },
                  { value: "Team B", label: "Team B" },
                  { value: "Team C", label: "Team C" },
                ]}
              />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.EVENTS}</span>
              <Select
                defaultValue="All"
                style={{ width: "100%" }}
                options={[
                  { value: "All", label: "All" },
                  { value: "Event A", label: "Event A" },
                  { value: "Event B", label: "Event B" },
                  { value: "Event C", label: "Event C" },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="transaction-info">
          <h3>{AppStrings.PAM_NEW_PROMOTION_ODDS_LIMIT}</h3>
          <div className="transaction-info-row">
            <div className="transaction-info-item">
              <span>{AppStrings.MIN_ODDS}</span>
              <Input placeholder="0" />
            </div>
            <div className="transaction-info-item">
              <span>{AppStrings.MAX_ODDS}</span>
              <Input placeholder="0" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PromoNotificationForm;
